import { useCallback } from 'react';

import { TSetRoutePoints } from '../types/setRoutePoints';
import { defaultRoutePoints } from '../utils';

const useResetRoutePoints = (setRoutePoints: TSetRoutePoints) => {
  const onResetRoutePoints = useCallback(() => {
    setRoutePoints(defaultRoutePoints);
  }, [setRoutePoints]);

  return onResetRoutePoints;
};

export default useResetRoutePoints;
